/* eslint-disable react/require-default-props */
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody, ModalHeader } from 'reactstrap';
import { getLink } from '../utils';
import HyperLink from './Hyperlink';

interface LoginModalProps {
  isOpen: boolean;
  type: string;
  toggle: (e: React.MouseEvent<HTMLElement>) => void;
  onExit: () => void;
  modalTitle: string;
  modalDescription: string;
  onClick: () => void;
  text?: string;
  secondaryButton?: boolean;
  showHyperlink?: boolean;
  hyperLinkText?: string;
  onClickHyperLink?: () => void;
  secondaryBtnText?: string;
  onClickSecondaryButton?: () => void;
}

export default function LoginModal({
  isOpen,
  toggle,
  onExit,
  type,
  modalTitle,
  modalDescription,
  text,
  onClick,
  secondaryBtnText,
  secondaryButton,
  onClickSecondaryButton,
  showHyperlink,
  hyperLinkText,
  onClickHyperLink,
  ...props
}: LoginModalProps) {
  const { t } = useTranslation('login_page');

  return (
    <SmlsModal
      isOpen={isOpen}
      type="right"
      toggle={toggle}
      onExit={onExit}
      className="smls-register-error-modal modal-response-status"
    >
      <ModalBody className="smls-modal-body">
        <div className="smls-modal-header">
          <h4>{modalTitle}</h4>
        </div>
        <div className="smls-modal-text">
          <p>{modalDescription}</p>
        </div>

        <div className="btns-modal-response">
          <SmlsButton className="primary-btn-modal" id="btn_gotIt" onClick={onClick} text={text} />

          {secondaryButton && (
            <SmlsButton
              color="hyperlink"
              type="button"
              className="padding forgot "
              text={secondaryBtnText}
              disabled={false}
              onClick={onClickSecondaryButton}
            />
          )}
          {showHyperlink && (
            <div className="mt-4">
              <HyperLink onClick={onClickHyperLink} text={hyperLinkText} />
            </div>
          )}
        </div>
      </ModalBody>
    </SmlsModal>
  );
}
